function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChairMark1 = function SvgChairMark1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 79 88"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M1630.98 352v36h-10.71v-9.333h5.36V356h-5.36v-14.667H1635V352zm-13.39 0v4h-44.18v-17.333h-8.04v-33.334a5.347 5.347 0 0 1 5.36-5.333h49.54a5.347 5.347 0 0 1 5.36 5.333v33.334h-8.04zm-49.54 6.667h54.9V376h-54.9zm2.68-2.667h-5.36v22.667h5.36V388h-10.71v-36H1556v-10.667h14.73z",
    style: {
      fill: "currentColor",
      fillRule: "evenodd"
    },
    transform: "translate(-1556 -300)"
  }));
};
export default SvgChairMark1;